'use client';

import { createContext, useContext, PropsWithChildren } from 'react';
import { PARENT_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';
import useCorporateTopCompany from './useCorporateTopCompany';
import {
  ICorporateTopFilterPayload,
  ITopCompaniesCorporateResponse,
} from '@/creditflowresearch/application/TopCompanies/corporateTopCompanies/interfaces';

type TopIssuersContextType = ReturnType<typeof useCorporateTopCompany>;

export const CorporateTopIssuersContext = createContext<TopIssuersContextType>(null);

export const useCorporateTopIssuersContext = () => {
  const context = useContext(CorporateTopIssuersContext);
  if (!context) {
    throw new Error('useCorporateTopIssuersContext must be used within the CorporateTopIssuersContext');
  }
  return context;
};

interface IProps {
  topParents?: ITopCompaniesCorporateResponse & { filters: ICorporateTopFilterPayload },
}

const CorporateTopIssuersContextProvider = ({ children, topParents }: PropsWithChildren<IProps>) => (
  <CorporateTopIssuersContext.Provider value={ useCorporateTopCompany({
      serverData: topParents,
      companyRole: PARENT_NAME,
    }) }
  >
    { children }
  </CorporateTopIssuersContext.Provider>
);

export default CorporateTopIssuersContextProvider;
